export default {
  common: {
    esg: {
      category: 'Catégorie',
      environment: 'Environnement',
      society: 'Social',
      governance: 'Gouvernance',
      other: 'Autres',
      comprehensive: 'Total',
      // basic: '',
    },
    btn: {
      cancel: 'Annuler',
      add: 'Ajouter',
      create: 'Créer',
      update: 'Mettre à jour',
      apply: 'Appliquer',
      close: 'Fermer',
      create_new: 'Créer Nouveau',
      edit: 'Modifier',
      detail: 'Détail',
      view_detail: 'Détail',
      delete: 'Supprimer',
      change: 'Changer',
      confirm: 'Confirmer',
      clear: 'Réinitialiser',
      download: 'Télécharger',
      save: 'Enregistrer',
      register: "S'inscrire",
      check_answer: 'Vérifier la réponse',
      score_card_list: 'Liste des fiches de notation',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: 'Téléchargement en masse',
    },
    link: {
      delete: 'Supprimer',
      back: 'Retour',
    },
    sentence: {
      back_to_login: 'Retour à la connexion',
      back_to_dashboard: 'Retour au tableau de bord',
      not_applicable: 'Non applicable*',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'Enquête',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'Sélectionner une enquête',
      target_year: 'Année',
      target_year_text: 'Sélectionner une année',
      target_company: 'Entreprise',
      target_company_text: 'Sélectionner une entreprise',
      total: 'Tout : {total}',
    },
    label: {
      required: 'Obligatoire',
      optional: 'Facultatif',
      year: 'Année',
    },
    form: {
      search_word: {
        label: 'Recherche de mots gratuite',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: "Date d'émission",
      evaluation_expires_date: "Date d'expiration",
      answer_expires_date: 'Délai',
      // last_updated_date: '',
    },
    error: {
      code_0005: "L'authentification a échoué. Veuillez vous connecter à nouveau",
      code_0007: 'Cette question est obligatoire',
      code_5001: 'Page introuvable',
      code_0001: 'La dernière enquête a déjà été soumise',
      code_0002: "Échec de la mise à jour, car les données les plus récentes ont été mises à jour à partir d'un autre appareil. Veuillez recharger et réessayer la mise à jour.",
      code_0003: 'Échec de la suppression du fichier. Veuillez le supprimer après avoir répondu à au moins une question.',
      code_0006: "L'utilisateur est déjà enregistré",
      code_0004: 'Ce fichier dépasse la taille de fichier téléchargeable. Veuillez noter que la taille ne doit pas dépasser 50 Mo.',
      code_9999: "Une erreur inattendue s'est produite",
    },
    evaluation: {
      title: 'Demander une évaluation',
      dashboard: 'Tableau de bord',
      analysis: 'Analyse',
      list: 'Liste des entreprises',
    },
    dashboard: {
      title: 'Tableau de bord',
    },
    upload: {
      title: 'Enquête',
      common: 'Commune',
    },
    scorecard: {
      title: 'Fiche de notation',
      list: 'Liste',
      detail: 'Détail',
      scorecard_detail: 'Détail de la fiche de notation',
      answer_preview: 'Aperçu des réponses',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: "Plan d'amélioration",
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: 'Analyse avancée',
    },
    settings: {
      title: 'Paramètres',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: 'FAQ',
    },
    logout: {
      title: 'Se déconnecter',
    },
    industry: {
      type_1: 'Agriculture, sylviculture et pêche',
      type_2: 'Exploitation minière, carrières et extraction de gravier',
      type_3: "Industrie de la construction (y compris la construction d'installations)",
      type_4: 'Industrie manufacturière (fer, acier, métaux non ferreux, produits métalliques)',
      type_5: 'Industrie manufacturière (machines, équipements, électronique, etc.)',
      type_6: 'Industrie manufacturière (aliments, boissons, tabac, etc.)',
      type_7: 'Industrie manufacturière (pâte à papier, papier, produits en papier)',
      type_8: 'Industrie manufacturière (bois, transformation des produits du bois)',
      type_9: 'Industrie manufacturière (industrie chimique, y compris les produits pharmaceutiques, industrie textile)',
      type_10: 'Industrie manufacturière (pétrole, charbon, caoutchouc, plastique, etc.)',
      type_11: 'Industrie manufacturière (imprimerie)',
      type_12: 'Industrie manufacturière (autres)',
      type_13: "Secteur de l'électricité, du gaz, de la chaleur et de l'eau",
      type_14: "Secteur de l'information et de la communication",
      type_15: "Secteur du transport et de l'entreposage",
      type_16: 'Commerce de gros et de détail',
      type_17: 'Secteur financier et des assurances',
      type_18: 'Secteur immobilier',
      type_19: "Écoles (y compris jardins d'enfants et garderies)",
      type_20: "Secteur de l'hébergement et de la restauration",
      type_21: 'Secteur des services liés à la vie (blanchisserie, coiffure, beauté, bains, etc.)',
      type_22: 'Services médicaux et sociaux',
      type_23: "Secteur de l'élimination et du recyclage des déchets",
      type_24: "Secteur de l'entretien automobile",
      type_25: 'Gouvernements locaux, autorités publiques, etc.',
      type_26: 'Autres',
    },
    scale: {
      a: '1〜29 personnes',
      b: '30〜99 personnes',
      c: '100〜499 personnes',
      d: '500〜999 personnes',
      e: '1000〜4999 personnes',
      f: 'plus de 5000 personnes',
    },
    sales_amount: {
      under_1million: '~1 million USD',
      under_10million: '1~10 millions USD',
      under_100million: '10~100 millions USD',
      under_1billion: '100 millions~1 milliard USD',
      under_10billion: '1~10 milliards USD',
      over_10billion: '10 milliards~ USD',
      not_disclose: 'Ne souhaite pas divulguer',
    },
    progress: 'Progrès',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'Répartition',
    help: 'Aide',
    user_display_mode: {
      my_assessment: 'Mon évaluation',
      supply_chain_assessment: "Évaluation de la chaîne d'approvisionnement",
    },
    buyer: 'Acheteur',
    supplier: 'Fournisseur',
    error_page: {
      section_one: 'Page introuvable',
      section_two: "Veuillez vérifier l'URL",
      to_dashboard: 'Retourner au tableau de bord',
    },
    priority: {
      good: 'Bien',
      high: 'Élevé',
      medium: 'Moyen',
      low: 'Faible',
    },
    priority_full_name: {
      high: 'Risque élevé',
      medium: 'Risque moyen',
      low: 'Risque faible',
    },
    faq: {
      how_to_use_csv_head: 'Pour ouvrir le fichier CSV téléchargé dans Excel, veuillez suivre les instructions ci-dessous.',
      how_to_use_csv_body_01: '1. Ouvrez un nouveau livre Excel vierge.',
      how_to_use_csv_body_02: "2. Dans l'onglet « Données », cliquez sur « À partir d'un texte ou d'un fichier CSV ».",
      how_to_use_csv_body_03: '3. Sélectionnez un fichier CSV et cliquez sur « Importer ».',
      how_to_use_csv_body_04: '4. Confirmez que le fichier a été importé correctement.',
      how_to_use_csv_body_05: '5. Sélectionnez « Charger ».',
      how_to_use_csv_note: "※ La procédure peut varier en fonction du système d'exploitation et de la version de Microsoft Excel utilisés.",
    },
    answer_display_status: {
      unanswered: 'Pas commencé',
      temporarily_saved: 'En cours',
      submitted: 'Soumis',
      score_rated: 'Évalué',
      ended: 'Fermé',
    },
    all: 'Tout',
    count: {
      // question: '',
      company: 'Entreprises',
      unit: 'articles',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'Statut',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: 'Entrer',
      half_digits: 'Chiffres demi-largeur',
    },
  },
};
